export const nameSurnameRegexp: RegExp = new RegExp(/^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]+(?:[-'’ ][A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]+)*$/);
